/** Нижнее меню и полноэкранный поиск включаются только у телефонов: строго меньше 768px. */
export const PHONE_NAV_MEDIA_QUERY = '(max-width: 767.98px)';
